const ratingsEndpoints = {
  base: "/v1/cms/ratings",
  byId: (id) => `/v1/cms/ratings/${encodeURIComponent(String(id || ""))}`,
  list: (tourId) =>
    `/v1/cms/ratings${tourId ? `?tourId=${encodeURIComponent(String(tourId || ""))}` : ""}`,
};

export default ratingsEndpoints;
